import { createAuthClient } from 'better-auth/react';

/**
 * The Better Auth browser client. It talks to our own `/api/auth/*`, so there's no
 * cross-origin request and the session cookie is httpOnly (doc 12).
 */
export const authClient = createAuthClient({ basePath: '/api/auth' });

export const { signIn, signUp, signOut, useSession, requestPasswordReset, resetPassword } =
  authClient;

/** Google is the primary sign-in. `next` survives the round trip through Google. */
export function signInWithGoogle(next?: string) {
  return authClient.signIn.social({
    provider: 'google',
    callbackURL: next && next.startsWith('/') ? next : '/',
  });
}

export async function resendVerificationEmail(email: string) {
  return authClient.sendVerificationEmail({ email, callbackURL: '/verify-email' });
}
